<mf-tool-bar
  [logoUrl]="logoUrl"
  [menuItems]="menuItems"
  [userName]="username"
  [clientName]="clientName"
  [quickAccessList]="quickAccessList"
  logoAlt="MiFinanzas" />
